"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PenIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class PenIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: fill, fillRule: "evenodd" },
                React.createElement("g", { fill: fill },
                    React.createElement("g", { transform: "translate(0.000000, 1.000000)" },
                        React.createElement("path", { d: "M10.498,15.6914 L9.771,19.6154 C9.734,19.8154 9.823,20.0194 9.996,20.1284 C10.169,20.2384 10.391,20.2304 10.557,20.1114 L13.789,17.7714 L10.498,15.6914 Z" }),
                        React.createElement("polygon", { points: "16.3745 6.0923 10.8955 14.7603 14.4585 17.0113 19.9375 8.3443" }),
                        React.createElement("path", { d: "M23.7109,5.3828 C24.2389,4.5468 24.0999,3.4808 23.4419,2.7968 L23.6389,2.4848 C23.7869,2.2518 23.7169,1.9438 23.4839,1.7948 L20.7679,0.0778 C20.5339,-0.0702 20.2259,-0.0002 20.0779,0.2328 L16.9089,5.2458 L20.4709,7.4988 L22.8719,3.6988 C23.0749,4.0468 23.0949,4.4868 22.8659,4.8488 L19.4309,10.2848 C19.2829,10.5188 19.3539,10.8268 19.5869,10.9748 C19.8199,11.1228 20.1289,11.0528 20.2759,10.8188 L23.7109,5.3828 Z" }),
                        React.createElement("path", { d: "M9.3535,20.1465 L7.8535,18.6465 C7.6585,18.4515 7.3415,18.4515 7.1465,18.6465 L5.4995,20.2925 L3.8535,18.6465 C3.6585,18.4515 3.3415,18.4515 3.1465,18.6465 L0.1465,21.6465 C-0.0495,21.8415 -0.0485,22.1585 0.1465,22.3535 C0.3415,22.5485 0.6575,22.5485 0.8535,22.3535 L3.4995,19.7065 L5.1465,21.3535 C5.3415,21.5485 5.6585,21.5485 5.8535,21.3535 L7.4995,19.7065 L8.6465,20.8535 C8.8415,21.0485 9.1585,21.0485 9.3535,20.8535 C9.5485,20.6585 9.5485,20.3415 9.3535,20.1465" }))))));
    }
}
exports.PenIcon = PenIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/pen.tsx
// module id = 2156
// module chunks = 0 1 2